<template>

  <div>
    <b-card>
      filter
    </b-card>

    <b-card>
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="50" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="submitReport">
        <b-row>
          <b-col md="12">
          <b-form-group :label="$t('Compactors')">
            <v-select multiple :close-on-select="false" v-model="request.compactors"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                      :options="[{ name: $t('all'), device_id: 'all' }, ...compactors]" :reduce="d => d.device_id" />
            <small v-if="errors && ('compactors' in errors)" class="text-danger">
              {{ $t(errors['compactors'][0]) }}
            </small>
          </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <h5>{{ $t('Start Time')}}</h5>
              <flat-pickr v-model="request.from" class="form-control" :config="datepicker"/>
              <small v-if="errors && ('from' in errors)" class="text-danger">
                {{ $t(errors['from'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <h5>{{ $t('End Time')}}</h5>
              <flat-pickr v-model="request.to" class="form-control" :config="datepicker"/>
              <small v-if="errors && ('to' in errors)" class="text-danger">
                {{ $t(errors['to'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col  cols="12">
            <b-form-group>
              <b-form-checkbox id="checkbox-1" v-model="request.service_type"
                  name="checkbox-1" value="served" unchecked-value="notServed">
                {{ $t('Served Containers')}}
              </b-form-checkbox>

              <b-form-checkbox id="checkbox-2" v-model="request.service_type"
                               name="checkbox-2" value="notServed" unchecked-value="served">
                {{ $t('Not Served Containers')}}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col  cols="12">
            <b-button type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

        </b-row>

      </b-form>
    </b-card>

    <b-card>

      <b-button :disabled="result.length < 1" @click="exportExcel('xlsx')" size="sm"  variant="primary" class="mr-1 mb-1">
        {{ $t('Excel Export') }}
      </b-button>

      <b-button :disabled="result.length < 1" @click="exportExcel('pdf')" size="sm" variant="primary" class="mr-1 mb-1">
        {{ $t('PDF Export') }}
      </b-button>

      <b-table id="my-table" responsive small bordered selectable hover
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :fields="[{key: 'i', label: '#'}, ...getFields]"
               :items="groupedData"
               :current-page="currentPage"
               :per-page="perPage"
               :tbody-tr-class="rowClass">

        <template #cell(i)="data">
          {{ data.index + 1 }}
        </template>

        <template #head()="data">
          <span class="text-info">{{ $t(data.label) }}</span>
        </template>

      </b-table>

      <div class="mb-1">
        <span class="text-muted">{{ $t('Showing') }}
              {{ ((currentPage - 1) * perPage + 1) }} to
              {{ Math.min( ((currentPage - 1) * perPage + 1)  + perPage - 1, result.length) }}
              of {{ result.length }} {{$t('entries')}}</span>
      </div>

      <b-pagination v-model="currentPage" :total-rows="result.length"
          :per-page="perPage" aria-controls="my-table"></b-pagination>

    </b-card>

  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, reactive, ref } from '@vue/composition-api'
import axios from '@/libs/axios'
import store from '@/store'
import fields from '@/views/reports/RFIDContainerDumpService/fields'
import datepicker from '@/views/reports/RFIDContainerDumpService/datepicker'

export default {
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    BLink,
    BMedia,
  },

  setup() {

    const currentPage = ref(1)

    const perPage = ref(50)
    const sortBy = ref('DATE')
    const sortDesc = ref(false)

    const result = ref([]);
    const errors = ref([]);

    const request = reactive({
      compactors: [],
      from: null,
      to: null,
      needPagination: false,
      service_type: 'served'
    })

    const loading = ref(false)
    const compactors = ref([])

    const promise = axios.get('userGetLinked', {params: {
        user: store.state.auth.userData.id,
        type: 'device',
        coles: 'device_id,name',
        category: 'COMPACTOR',
        hasRelation: 'plans,containerDump',

    }})

    promise.then(res => {
      compactors.value = res.data.data
    })

    promise.catch(e => {
      console.log('error load compactors list')
    })


    const getFields = computed(() => {
      if (request.service_type === 'notServed') {
         return fields.filter(obj => obj.key !== 'event_time');
      }

      return fields;
    })


    const submitReport = () => {

      loading.value = true
      errors.value = []
      const promise = axios.post('reports', {
        type: 'RFIDContainerDumpService',
        ...request })

      promise.then(res => result.value = res.data.data)

      promise.catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
        }
      })

      promise.finally(_ => loading.value = false)

    }

    const rowClass = (item, type) => {
      let class_name = 'text-center'
      if (item.isGroup)  class_name += ' table-primary'
      return class_name
    }


    const exportExcel = type => {
      const promise = axios.post('export', {
        exporter: type,
        export: "RFIDContainerDumpServiceReport",
        type: 'RFIDContainerDumpService', ...request }, {responseType: 'blob'})

      promise.then(res => {
        const blob = new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `RFIDContainerDumpService_${request.service_type}_Report.${type}`;
        link.click();
        URL.revokeObjectURL(url);
      })

      promise.catch(e => {
        console.log(e)
        console.log('error export report')
      })

    }

    const groupedData =  computed(() => {

      const grouped = []
      let currentRow = null
      let lastCount = 0
      let lastRow;

      result.value.forEach(item => {

        if (currentRow === `${item.device}.${item.date}`) {
          lastCount++;
          grouped.push(item)
        }

        else
        {

          if (currentRow !== null) {
            grouped.push({
              isGroup: true,
              tag: lastCount,
              device: lastRow.device,
              date: lastRow.date,
              plan: lastRow.plan,
              owner: lastRow.owner,
              contract: lastRow.contract
            })
          }

          lastCount = 1
          grouped.push(item)
        }

        lastRow = item
        currentRow = `${item.device}.${item.date}`
      })

      if (result.value.length > 0) {
        grouped.push({
          isGroup: true,
          tag: lastCount,
          device: lastRow.device,
          date: lastRow.date,
          plan: lastRow.plan,
          owner: lastRow.owner,
          contract: lastRow.contract
        })
      }

      return grouped

    })


    return {
      rowClass,
      groupedData,
      currentPage,
      perPage,
      sortBy, sortDesc,
      getFields,datepicker,

      result, errors,
      loading,
      compactors,
      request,
      submitReport,
      exportExcel
    }
  }
}

</script>

<style>
.table-primary > td {
  background-color: #27afba !important;
  border-radius: 0 !important;
}

</style>